import { createContext, useContext, useState, useCallback } from 'react';

const ConsoleViewerContext = createContext();

export function ConsoleViewerProvider({ children }) {
  const [isVisible, setIsVisible] = useState(false);
  const [panelWidth, setPanelWidth] = useState(600);

  const showConsoleViewer = useCallback(() => {
    setIsVisible(true);
  }, []);

  const hideConsoleViewer = useCallback(() => {
    setIsVisible(false);
  }, []);

  const toggleConsoleViewer = useCallback(() => {
    setIsVisible(prev => !prev);
  }, []);

  const updatePanelWidth = useCallback((width) => {
    setPanelWidth(width);
  }, []);

  const value = {
    isVisible,
    panelWidth,
    showConsoleViewer,
    hideConsoleViewer,
    toggleConsoleViewer,
    updatePanelWidth
  };

  return (
    <ConsoleViewerContext.Provider value={value}>
      {children}
    </ConsoleViewerContext.Provider>
  );
}

export function useConsoleViewer() {
  const context = useContext(ConsoleViewerContext);
  if (!context) {
    throw new Error('useConsoleViewer must be used within a ConsoleViewerProvider');
  }
  return context;
} 